import { render, staticRenderFns } from "./EditOrderItemsModal.vue?vue&type=template&id=3b24511a&"
import script from "./EditOrderItemsModal.vue?vue&type=script&lang=js&"
export * from "./EditOrderItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports